export default class FormatData {

  static formatDateTime(val?: string|undefined) {
    if (val) {
      return new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(val));
    }
    return "";
  }

  static formatDate(val?: string|undefined) {
    if (val) {
      return new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "numeric",
        day: "2-digit",
      }).format(new Date(val));
    }
    return "";
  }
  static formatYesNo(val: number | boolean) {
    return val ? "yes" : "no";
  }

  static formatActive(val: number | boolean) {
    return val ? 'active' : 'inactive';
  }

  static generatePaginationURLPath(query: any) {
    let path = `?page=${query.page}&pageSize=${query.pageSize}`;
    if (query.sortField && query.sortOrder)
      path += `&sortField=${query.sortField}&sortOrder=${query.sortOrder}`;

    if (query.filters) {
      for (let key in query.filters) {
        let value = query.filters[key];
        if (value) {
          if (Array.isArray(value)) { value.join(",") }
          path += `&${key}=${query.filters[key]}`;
        }
      }
    }

    if (query.customSearch) {
      for (let key in query.customSearch) {
        if (query.customSearch[key]) {
          path += `&${key}=${query.customSearch[key]}`;
        }
      }
    }
    return path
  }
}
